import React from 'react';
import { connect } from 'react-redux';

import styles from './loginFirst.module.css';
import ServiceButton from '../DesktopView/ServiceButton';
import { go } from '../../../routes';
import { practiceProfilePropType } from '../../propTypes/index';


const LoginFirst = ({ clinic, token }) => (
  <div className={styles.container}>
    <div style={{ width: "70%" }}>You must login or provide your details before the available appointment slots can be displayed</div>
    <div>
      <ServiceButton
        type={3}
        service={3}
        onClick={() => {
          if (token)
            go.selection(clinic.UrlName);
          else
            go.welcome(clinic.UrlName);
        }} />
    </div>
  </div>
);

LoginFirst.propTypes = {
  clinic: practiceProfilePropType.isRequired,
};

const mapStateToProps = state => ({
  token: state.loginReducer.token,
});

export default connect(
  mapStateToProps,
)(LoginFirst);
